import React, { SVGProps } from "react";
const SvgRealEstate = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width={25.976} viewBox="0 0 25.976 28.634" {...props}>
      <g data-name="Real Estate">
        <path
          data-name="Path 715"
          d="M22.015 28.21H3.977L3.96 1.679h18.038Z"
          fill="#12b05e"
        />
        <path
          data-name="Path 716"
          d="M21.999 1.679h-2.5l.017 26.532h2.5Z"
          fill="#55a2f0"
        />
        <path
          data-name="Path 717"
          d="M15.211 28.209h-4.447v-8.368a.286.286 0 0 1 .286-.286h3.876a.286.286 0 0 1 .286.286v8.368Z"
          fill="#ffb125"
        />
        <g data-name="Group 241" fill="#fff">
          <path
            data-name="Path 718"
            d="M8.823 23.319h-2.72a.164.164 0 0 1-.164-.164V19.72a.164.164 0 0 1 .164-.164h2.72a.164.164 0 0 1 .164.164v3.435a.164.164 0 0 1-.164.164Z"
          />
          <path
            data-name="Path 719"
            d="M19.873 23.319h-2.72a.164.164 0 0 1-.164-.164V19.72a.164.164 0 0 1 .164-.164h2.72a.164.164 0 0 1 .164.164v3.435a.164.164 0 0 1-.164.164Z"
          />
        </g>
        <path
          data-name="Path 720"
          d="M22.902.41H3.073a.122.122 0 0 0-.122.122v1.4a.122.122 0 0 0 .122.122h19.829a.122.122 0 0 0 .118-.124V.53a.122.122 0 0 0-.118-.12Z"
          fill="#ffb125"
        />
        <g data-name="Group 242" fill="#fff">
          <path
            data-name="Path 721"
            d="M8.823 15.552h-2.72a.164.164 0 0 1-.164-.164v-3.435a.164.164 0 0 1 .164-.164h2.72a.164.164 0 0 1 .164.164v3.435a.164.164 0 0 1-.164.164Z"
          />
          <path
            data-name="Path 722"
            d="M14.348 15.552h-2.72a.164.164 0 0 1-.164-.164v-3.435a.164.164 0 0 1 .164-.164h2.72a.164.164 0 0 1 .164.164v3.435a.164.164 0 0 1-.164.164Z"
          />
          <path
            data-name="Path 723"
            d="M19.873 15.552h-2.72a.164.164 0 0 1-.164-.164v-3.435a.164.164 0 0 1 .164-.164h2.72a.164.164 0 0 1 .164.164v3.435a.164.164 0 0 1-.164.164Z"
          />
          <path
            data-name="Path 724"
            d="M8.823 8.411h-2.72a.164.164 0 0 1-.164-.164V4.811a.164.164 0 0 1 .164-.164h2.72a.164.164 0 0 1 .164.164v3.436a.164.164 0 0 1-.164.164Z"
          />
          <path
            data-name="Path 725"
            d="M14.348 8.411h-2.72a.164.164 0 0 1-.164-.164V4.811a.164.164 0 0 1 .164-.164h2.72a.164.164 0 0 1 .164.164v3.436a.164.164 0 0 1-.164.164Z"
          />
          <path
            data-name="Path 726"
            d="M19.873 8.411h-2.72a.164.164 0 0 1-.164-.164V4.811a.164.164 0 0 1 .164-.164h2.72a.164.164 0 0 1 .164.164v3.436a.164.164 0 0 1-.164.164Z"
          />
        </g>
        <g data-name="Group 243" fill="#b6fa4d">
          <path
            data-name="Path 727"
            d="M7.419 27.048a1.6 1.6 0 0 0-1.425-1.557 2.079 2.079 0 0 0-3.793 1.557Z"
          />
          <path
            data-name="Path 728"
            d="M18.557 27.048a1.6 1.6 0 0 1 1.425-1.557 2.079 2.079 0 0 1 3.793 1.557Z"
          />
        </g>
        <path
          data-name="Path 729"
          d="M22.966.426h-2.444v1.626h2.381a.122.122 0 0 0 .122-.122V.53a.121.121 0 0 0-.059-.104Z"
          fill="#ff901d"
        />
        <path
          data-name="Path 730"
          d="M24.86 26.81H1.116a.708.708 0 0 0-.708.708.708.708 0 0 0 .708.708H24.86a.708.708 0 0 0 .708-.708.708.708 0 0 0-.708-.708Z"
          fill="#7d0"
        />
        <path
          data-name="Path 731"
          d="m25.434 27.93.019-.027.017-.028.016-.029.014-.03.014-.03c0-.01.008-.021.012-.031l.011-.032.008-.033.008-.033c.002-.011 0-.024.005-.036s0-.022 0-.033V27.411c0-.009-.006-.036-.01-.054l-.006-.026q-.009-.032-.02-.062v-.012a.7.7 0 0 0-.032-.069v-.007a.707.707 0 0 0-.622-.371h-1.8a.741.741 0 0 1-.741.741H1.116a.707.707 0 0 1-.622-.371.706.706 0 0 0-.083.393.722.722 0 0 0 .727.651h23.815l.045-.007.027-.006.039-.01.028-.009.036-.013.027-.012.033-.016.027-.015.03-.018.026-.018.028-.021.024-.02.025-.023.022-.022.023-.025.021-.025Z"
          fill="#6ec102"
        />
        <g data-name="Group 244" fill="#e1effb">
          <path
            data-name="Path 732"
            d="M8.823 4.647h-1.36v3.764h1.36a.164.164 0 0 0 .164-.164V4.811a.164.164 0 0 0-.164-.164Z"
          />
          <path
            data-name="Path 733"
            d="M14.348 4.647h-1.36v3.764h1.36a.164.164 0 0 0 .164-.164V4.811a.164.164 0 0 0-.164-.164Z"
          />
          <path
            data-name="Path 734"
            d="M19.873 4.647h-1.36v3.764h1.36a.164.164 0 0 0 .164-.164V4.811a.164.164 0 0 0-.164-.164Z"
          />
          <path
            data-name="Path 735"
            d="M8.823 11.788h-1.36v3.764h1.36a.164.164 0 0 0 .164-.164v-3.435a.164.164 0 0 0-.164-.165Z"
          />
          <path
            data-name="Path 736"
            d="M14.348 11.788h-1.36v3.764h1.36a.164.164 0 0 0 .164-.164v-3.435a.164.164 0 0 0-.164-.165Z"
          />
          <path
            data-name="Path 737"
            d="M19.873 11.788h-1.36v3.764h1.36a.164.164 0 0 0 .164-.164v-3.435a.164.164 0 0 0-.164-.165Z"
          />
          <path
            data-name="Path 738"
            d="M8.823 19.556h-1.36v3.764h1.36a.164.164 0 0 0 .164-.164v-3.435a.164.164 0 0 0-.164-.165Z"
          />
          <path
            data-name="Path 739"
            d="M19.873 19.556h-1.36v3.764h1.36a.164.164 0 0 0 .164-.164v-3.435a.164.164 0 0 0-.164-.165Z"
          />
        </g>
        <path
          data-name="Path 740"
          d="M14.061 22.413a.408.408 0 0 0-.408.408v.844a.408.408 0 1 0 .816 0v-.844a.408.408 0 0 0-.408-.408Z"
        />
        <path
          data-name="Path 741"
          d="M5.53 23.155a.573.573 0 0 0 .573.573h2.72a.573.573 0 0 0 .573-.573V19.72a.573.573 0 0 0-.573-.573h-2.72a.573.573 0 0 0-.573.573v3.435Zm.816-3.191h2.232v2.948H6.346Z"
        />
        <path
          data-name="Path 742"
          d="M16.58 23.155a.573.573 0 0 0 .572.573h2.72a.573.573 0 0 0 .572-.573V19.72a.573.573 0 0 0-.572-.573h-2.72a.573.573 0 0 0-.572.573Zm.816-3.191h2.232v2.948h-2.232Z"
        />
        <path
          data-name="Path 743"
          d="M5.53 15.388a.573.573 0 0 0 .573.572h2.72a.573.573 0 0 0 .573-.572v-3.435a.573.573 0 0 0-.573-.573h-2.72a.573.573 0 0 0-.573.573v3.435Zm.816-3.191h2.232v2.948H6.346Z"
        />
        <path
          data-name="Path 744"
          d="M11.055 15.388a.573.573 0 0 0 .573.572h2.72a.573.573 0 0 0 .573-.572v-3.435a.573.573 0 0 0-.573-.573h-2.72a.573.573 0 0 0-.573.573Zm.816-3.191h2.237v2.948h-2.232v-2.952Z"
        />
        <path
          data-name="Path 745"
          d="M16.58 15.388a.573.573 0 0 0 .572.572h2.72a.573.573 0 0 0 .572-.572v-3.435a.573.573 0 0 0-.572-.573h-2.72a.573.573 0 0 0-.572.573Zm.816-3.191h2.232v2.948h-2.232Z"
        />
        <path
          data-name="Path 746"
          d="M6.103 8.819h2.72a.573.573 0 0 0 .572-.573V4.811a.573.573 0 0 0-.572-.572h-2.72a.573.573 0 0 0-.572.572v3.436a.573.573 0 0 0 .572.572Zm.244-3.764h2.23v2.948H6.345Z"
        />
        <path
          data-name="Path 747"
          d="M11.628 8.819h2.72a.573.573 0 0 0 .573-.573V4.811a.573.573 0 0 0-.573-.572h-2.72a.573.573 0 0 0-.573.572v3.436a.573.573 0 0 0 .573.572Zm.244-3.764h2.236v2.948h-2.232V5.055Z"
        />
        <path
          data-name="Path 748"
          d="M17.153 8.819h2.72a.573.573 0 0 0 .572-.573V4.811a.573.573 0 0 0-.572-.572h-2.72a.573.573 0 0 0-.572.572v3.436a.573.573 0 0 0 .572.572Zm.244-3.764h2.232v2.948h-2.232Z"
        />
        <path
          data-name="Path 749"
          d="M24.86 26.4h-.634a2.493 2.493 0 0 0-1.8-2.2l-.019-21.739h.5a.531.531 0 0 0 .53-.53V.53a.531.531 0 0 0-.53-.53h-2.846a.408.408 0 0 0 0 .816h2.555v.828H3.359V.816h14.149a.408.408 0 0 0 0-.816H3.073a.531.531 0 0 0-.53.53v1.4a.531.531 0 0 0 .53.53h.479l.009 13.728a.408.408 0 0 0 .408.408.408.408 0 0 0 .408-.408L4.369 2.461h17.222l.014 21.647h-.042l-.1.009-.054.008-.087.013-.058.011-.08.017-.06.015-.077.021-.06.019-.074.025-.059.022-.072.029-.058.026-.069.033-.057.029-.067.037-.055.032-.066.041-.053.034-.064.045-.05.037-.062.05-.047.039-.061.055-.043.04-.061.061-.038.04c-.022.023-.043.048-.064.072l-.031.032q-.046.055-.088.113c-.047.01-.093.021-.138.034l-.044.014-.09.03-.051.02-.08.034-.051.023-.077.039-.047.026-.08.048-.039.024a1.753 1.753 0 0 0-.112.08l-.007.006q-.051.04-.1.083l-.034.032a1.335 1.335 0 0 0-.066.064l-.037.039-.058.064-.035.042a1.255 1.255 0 0 0-.053.069l-.031.043a2.153 2.153 0 0 0-.052.079l-.024.038a1.81 1.81 0 0 0-.068.122v.009q-.029.058-.055.118l-.017.044-.026.065H15.62v-6.561a.7.7 0 0 0-.694-.694H11.05a.7.7 0 0 0-.694.694V26.4H7.71l-.026-.065-.017-.044q-.025-.059-.054-.117v-.01a2.093 2.093 0 0 0-.068-.122l-.025-.038a1.51 1.51 0 0 0-.052-.078l-.032-.043a1.766 1.766 0 0 0-.053-.068l-.036-.043-.057-.064-.037-.039a1.299 1.299 0 0 0-.066-.063l-.035-.032q-.049-.043-.1-.083l-.007-.006a1.774 1.774 0 0 0-.113-.08l-.039-.024a1.302 1.302 0 0 0-.08-.048l-.047-.026-.078-.039-.05-.023-.081-.034-.05-.019-.091-.03-.044-.014a1.544 1.544 0 0 0-.138-.034q-.043-.058-.088-.113l-.031-.035-.063-.072-.039-.04-.06-.061-.044-.04-.06-.054-.047-.039-.062-.049-.05-.037-.063-.045-.052-.034-.065-.041-.054-.032-.068-.037-.056-.029-.07-.033-.057-.025-.072-.029-.058-.022L5 24.222l-.058-.018-.079-.021-.057-.015-.085-.018-.053-.011-.1-.015-.038-.006q-.07-.008-.14-.012v-5.333a.408.408 0 0 0-.408-.408.408.408 0 0 0-.408.408v5.418A2.492 2.492 0 0 0 1.75 26.4h-.634a1.116 1.116 0 1 0 0 2.231H24.86a1.116 1.116 0 0 0 0-2.231Zm-5.65-.047a.83.83 0 0 1 .054-.064l.014-.016a1.127 1.127 0 0 1 .119-.112l.017-.014a.988.988 0 0 1 .065-.048c.023-.016.047-.03.071-.044l.019-.011c.024-.013.048-.026.073-.037.025-.012.052-.022.078-.032l.021-.008.08-.026c.028-.008.056-.014.084-.02h.022c.029-.005.057-.01.087-.013a.408.408 0 0 0 .3-.189 1.663 1.663 0 0 1 1.418-.787H21.837c.035 0 .07.006.106.01a1.675 1.675 0 0 1 1.464 1.458h-4.231l.034-.045Zm-8.037-6.391h3.631V26.4h-3.632v-6.436Zm-7.15 4.97c.035 0 .068-.007.1-.009h.113a1.664 1.664 0 0 1 1.418.787.413.413 0 0 0 .3.189c.029 0 .058.008.086.013h.022a1.067 1.067 0 0 1 .164.046l.021.008.078.032c.025.012.049.024.073.038l.019.011.071.044c.022.015.044.032.065.048l.017.013c.022.018.043.036.063.055.02.018.038.038.057.058l.014.016c.019.021.037.042.054.064.012.015.022.031.033.047H2.569a1.675 1.675 0 0 1 1.453-1.458Zm20.837 2.883H1.116a.3.3 0 1 1 0-.6H24.86a.3.3 0 1 1 0 .6Z"
        />
      </g>
    </svg>
  );
};
export default SvgRealEstate;
